import React from "react";
import { texts, CHtexts, RUtexts } from "./common";
import merge from "deepmerge";
import cloneDeep from "lodash/cloneDeep";
// import Compass from "./components/Compass";
// import MultiLineText from "../../components/svg/MultiLineText";
import { assetsPath } from "../../utils";

const overwriteMerge = (destinationArray, sourceArray, options) => {
  const destination = destinationArray.slice();

  sourceArray.forEach((e, i) => {
    Object.keys(e).forEach((key) => {
      // console.log(destination[0][key])
      destination[i][key] = sourceArray[i][key];
    });
  });

  return destination;
};

const switchLanguage = (activeLanguage) => {
  switch (activeLanguage) {
    case "cn":
      return CHtexts;
    case "ru":
      return RUtexts;
    default:
      return texts;
  }
};

export default ({
  x = 0,
  y = 0,
  width = "100%",
  height,
  children,
  activeLanguage,
  filterTexts,
  project = "laguna-seaside-residences",
}) => {
  const selActiveLanguage = switchLanguage(activeLanguage);
  const mergedTexts = merge(cloneDeep(texts), selActiveLanguage, {
    arrayMerge: overwriteMerge,
  });
  const textForRender =
    typeof filterTexts === "function" ? filterTexts(mergedTexts) : mergedTexts;
  // // const baseAssetUrl = assetsPath("phuket-laguna-park-2");
  // const baseAssetUrl = assetsPath("phuket-skypark");
  const baseAssetUrl = assetsPath(project);
  const bg = `${baseAssetUrl}/images/project-map/phuket-masterplan-${activeLanguage}.png`;

  console.log("masterplan >>>> ", project);

  return (
    <svg
      // className="project-map"
      className="project-masterplan"
      viewBox="0 0 1630 1080"
      x={x}
      y={y}
      width={width}
      heigth={height}
    >
      <image xlinkHref={bg} width={1630} height={1080} />
      {/* <g>
        {textForRender.map((element, i) => (
          <MultiLineText key={`ele-${i}`} {...element} />
        ))}
      </g> */}
      {/* <Compass x={630} y={50} width={44} height={44} /> */}
      {children}
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/containers/ProjectMap/PhuketMasterplan.js